import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as AuthAPI from '../services/authAPI';
import Field from '../components/Field';

export default function ForgotPasswordPage() {

    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async event => {
        event.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        setError('');
        try {
            await AuthAPI.forgotPassword(email);
            setSuccess(true);
        } catch {
            setError('Service indisponible');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <section className="vh-100">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                            <div className="card shadow-2-strong">
                                <div className="card-body p-5 text-center">
                                    <h3 className="mb-5">Mot de passe oublié</h3>
                                    {success ? (
                                        <p className="text-success">
                                            Si un compte existe avec cet email, vous recevrez un lien de réinitialisation sous peu.
                                        </p>
                                    ) : (
                                        <form onSubmit={handleSubmit}>
                                            <Field
                                                name="email"
                                                label="Adresse électronique"
                                                value={email}
                                                onChange={e => setEmail(e.currentTarget.value)}
                                                type="email"
                                                error={error}
                                            />
                                            {error && <p className="text-danger text-center">{error}</p>}
                                            <div className="row mb-4">
                                                <button type="submit" disabled={submitting} className="col-md btn btn-primary">{submitting ? "Envoi..." : "Envoyer le lien"}</button>
                                            </div>
                                        </form>
                                    )}
                                    <a href="#!" onClick={e => { e.preventDefault(); navigate('/login'); }}>Retour à la connexion</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
